import { Map, List, fromJS } from 'immutable'

export function dataTable(state = Map(), { type, table_id, ...vars }) {
  if (!table_id) return state
  let items, item, data

  switch (type) {
    // Handle fetching
    case 'DATATABLE_ITEMS_FETCH_LOADING':
      return state.setIn([table_id, 'fetchLoading'], vars.loading || false)

    case 'DATATABLE_ITEMS_FETCH_ERROR':
      return state.setIn([table_id, 'fetchError'], vars.message || false)

    case 'DATATABLE_ITEMS_FETCH_SUCCESS':
      return state
        .setIn([table_id, 'items'], List.isList(vars.items) ? vars.items : fromJS(vars.items))
        .setIn([table_id, 'meta'], Map.isMap(vars.meta) ? vars.meta : fromJS(vars.meta))

    // Handle create
    case 'DATATABLE_ITEM_CREATE_LOADING':
      return state.setIn([table_id, 'createLoading'], vars.loading || false)

    case 'DATATABLE_ITEM_CREATE_ERROR':
      return state.setIn([table_id, 'createError'], vars.message || false)

    // case 'DATATABLE_ITEM_CREATE_SUCCESS':
    //   items = state.getIn([table_id, 'items'], List())
    //   return state.setIn([table_id, 'items'], items.push(Map.isMap(vars.item) ? item : fromJS(vars.item)))

    // Handle update
    case 'DATATABLE_ITEM_UPDATE_LOADING':
      return state.setIn([table_id, 'updateLoading'], vars.loading || false)

    case 'DATATABLE_ITEM_UPDATE_ERROR':
      return state.setIn([table_id, 'updateError'], vars.message || false)

    case 'DATATABLE_ITEM_UPDATE_SUCCESS':
      item = Map.isMap(vars.item) ? item : fromJS(vars.item)
      items = state.getIn([table_id, 'items'], List()).map(i => (i.get('id') === vars.item_id ? item : i))

      return state.setIn([table_id, 'items'], items)

    // Handle delete
    case 'DATATABLE_ITEM_DELETE_LOADING':
      return state.setIn([table_id, 'deleteLoading'], vars.loading || false)

    case 'DATATABLE_ITEM_DELETE_ERROR':
      return state.setIn([table_id, 'deleteError'], vars.message || false)

    case 'DATATABLE_ITEM_DELETE_SUCCESS':
      items = state.getIn([table_id, 'items'], List()).filter(i => (i.get('id') === vars.item_id ? false : true))

      return state.setIn([table_id, 'items'], items)

    // Handle config
    case 'DATATABLE_CONFIG_FETCH_LOADING':
      return state.setIn([table_id, 'configLoading'], vars.loading || false)

    case 'DATATABLE_CONFIG_FETCH_ERROR':
      return state.setIn([table_id, 'configError'], vars.message || false)

    case 'DATATABLE_CONFIG_FETCH_SUCCESS':
      data = vars.data || {}

      return state.setIn([table_id, 'config', 'formFields'], fromJS(data.formFields || []))

    case 'TASK_CREATE_SUCCESS':
      if (!state.has('tasks')) return state

      let createdTask = fromJS(vars.item || false)
      if (!Map.isMap(createdTask)) return state

      return state.setIn(['tasks', 'items'], state.getIn(['tasks', 'items'], List()).push(createdTask))

    case 'TASK_EDIT_SUCCESS':
      if (!state.has('tasks')) return state

      let updatedTask = fromJS(vars.item || false)
      if (!Map.isMap(updatedTask)) return state

      return state.setIn(
        ['tasks', 'items'],
        state.getIn(['tasks', 'items'], List()).map(t => (t.get('id') === updatedTask.get('id') ? updatedTask : t))
      )

    case 'TASK_DELETE_SUCCESS':
      if (!state.has('tasks')) return state

      return state.setIn(
        ['tasks', 'items'],
        state.getIn(['tasks', 'items'], List()).filter(t => t.get('id') !== vars.item_id)
      )

    case 'CONTACT_CREATE_SUCCESS':
      if (!state.has('contacts')) return state

      let createdContact = fromJS(vars.item || false)
      if (!Map.isMap(createdContact)) return state

      return state.setIn(['contacts', 'items'], state.getIn(['contacts', 'items'], List()).push(createdContact))

    case 'CONTACT_EDIT_SUCCESS':
      if (!state.has('contacts')) return state

      let updatedContact = fromJS(vars.item || false)
      if (!Map.isMap(updatedContact)) return state

      return state.setIn(
        ['contacts', 'items'],
        state
          .getIn(['contacts', 'items'], List())
          .map(t => (t.get('id') === updatedContact.get('id') ? updatedContact : t))
      )

    case 'FILES_UPLOADED':
      if (!state.has('files')) return state

      let uploadedFiles = fromJS(vars.files || false)

      if (!List.isList(uploadedFiles)) return state

      return state.setIn(['files', 'items'], uploadedFiles.concat(state.getIn(['files', 'items'], List())))

    case 'INTERVIEW_STATUS_SUCCESS':
      if (!state.has('interviews')) return state

      let updatedInterview = fromJS(vars.item || false)
      if (!Map.isMap(updatedInterview)) return state

      return state.setIn(
        ['interviews', 'items'],
        state
          .getIn(['interviews', 'items'], List())
          .map(t => (t.get('id') === updatedInterview.get('id') ? t.set('status', updatedInterview.get('status')) : t))
      )

    case 'SUBSCRIPTION_RENEW_STATUS_SUCCESS':
      if (!state.has('subscriptions')) return state

      return state.setIn(
        ['subscriptions', 'items'],
        state
          .getIn(['subscriptions', 'items'], List())
          .map(t => (t.get('id') === vars.subscription_id ? t.setIn(['data', 'renew_status'], vars.renew_status) : t))
      )

    case 'SUBSCRIPTION_NOTIFICATION_STATUS_SUCCESS':
      if (!state.has('subscriptions')) return state

      return state.setIn(
        ['subscriptions', 'items'],
        state
          .getIn(['subscriptions', 'items'], List())
          .map(t =>
            t.get('id') === vars.subscription_id
              ? t.setIn(['data', 'notification_status'], vars.notification_status)
              : t
          )
      )

    default:
      return state
  }
}
